import { render, staticRenderFns } from "./PremiumCandle.vue?vue&type=template&id=28f63718&scoped=true&"
import script from "./PremiumCandle.vue?vue&type=script&lang=js&"
export * from "./PremiumCandle.vue?vue&type=script&lang=js&"
import style0 from "./PremiumCandle.vue?vue&type=style&index=0&id=28f63718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f63718",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
